

class CoinGeckoClient {
  BASE_URL = "https://external-web-proxy.coinledger.io/pro-api.coingecko.com";

  async getCurrentCoinPrice(assetId, fiatId) {
    const url = new URL(`${this.BASE_URL}/simple/price`);
    url.searchParams.set("ids", assetId);
    url.searchParams.set("vs_currencies", fiatId);

    const res = await fetch(url);
    let price;
    if (res.ok) {
      const json = await res.json();
      price = json?.[assetId]?.[fiatId];
    }

    console.log(res.statusText);
    return {
      price: price,
      error: price ? null : res.statusText,
    };
  }

  async getPastCoinPrice(assetId, date) {
    const url = new URL(`${this.BASE_URL}/coins/${assetId}/history`);
    url.searchParams.set("localization", "false");
    url.searchParams.set("date", date);

    const res = await fetch(url);
    let price;
    if (res.ok) {
      const json = await res.json();
      price = json?.market_data?.current_price?.usd;
    }

    return {
      price: price,
      error: price ? null : res.statusText
    }
  }

  async getPriceChartData(assetId, fiatId) {
    const url = new URL(`${this.BASE_URL}/coins/${assetId}/market_chart`);
    url.searchParams.set("vs_currency", fiatId);
    url.searchParams.set("days", "max");
    url.searchParams.set("interval", "daily");

    const res = await fetch(url);
    let prices;
    let marketCaps;
    if (res.ok) {
      const json = await res.json();
      prices = json?.prices;
      marketCaps = json?.market_caps;
    }

    return {
      prices,
      marketCaps,
      error: prices ? null : res.statusText
    }
  }

  async getCryptoMarketCapChartData(fiatId) {
    const url = new URL(`${this.BASE_URL}/global/market_cap_chart`);
    url.searchParams.set('vs_currency', fiatId);
    url.searchParams.set('days', 'max');

    const res = await fetch(url);
    let marketCaps;
    if (res.ok) {
      const json = await res.json();
      marketCaps = json?.market_cap_chart?.market_cap;
    }

    return {
      marketCaps,
      error: marketCaps ? null : res.statusText
    }
  }
}

export default new CoinGeckoClient();
